export default __webpack_public_path__ + "fe222452212b0c4dff8cacae266609bd.svg";